import { render, staticRenderFns } from "./Swissgenetics-Card.vue?vue&type=template&id=7eee32d3&scoped=true&"
import script from "./Swissgenetics-Card.vue?vue&type=script&lang=js&"
export * from "./Swissgenetics-Card.vue?vue&type=script&lang=js&"
import style0 from "./Swissgenetics-Card.vue?vue&type=style&index=0&style=scss&lang=css&"
import style1 from "./Swissgenetics-Card.vue?vue&type=style&index=1&id=7eee32d3&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eee32d3",
  null
  
)

export default component.exports